/* France & Son PDP copy and spacing guard.
 *
 * Product apps hydrate after the theme. This intentionally observes only the
 * product purchase area for a short startup window, so the final buyer-facing
 * copy is present without a permanent whole-page observer or layout shift.
 */
(function () {
  'use strict';

  var quoteLabel = 'Request a Trade Quote';
  var roomLabel = 'Reveal Designer Suggestions';
  var roomDetail = 'Curated complements for this piece.';
  var scheduled = false;
  var observer;
  var recommendationFallbackTimer;

  function textOf(element) {
    return (element && element.textContent ? element.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function setText(element, value) {
    if (element && textOf(element) !== value) element.textContent = value;
  }

  function applyCopy(scope) {
    scope.querySelectorAll('.storeify-quote-btn-trigger-popup').forEach(function (button) {
      setText(button, quoteLabel);
      button.setAttribute('aria-label', quoteLabel);
    });

    scope.querySelectorAll('[data-ais-product-room-entry]').forEach(function (entry) {
      var button = entry.querySelector('.ais-product-room-btn');
      var label = entry.querySelector('.ais-product-room-btn-label');
      var detail = entry.querySelector('.ais-product-room-btn-detail');
      var productTitle = button && button.getAttribute('data-ais-product-title');

      setText(label, roomLabel);
      setText(detail, roomDetail);
      if (button) button.setAttribute('aria-label', roomLabel + (productTitle ? ': ' + productTitle : ''));
    });
  }

  function bindQuoteFallback(scope) {
    scope.querySelectorAll('[data-fs-quote-reserve]').forEach(function (fallback) {
      if (fallback.dataset.fsQuoteBound === 'true') return;
      fallback.dataset.fsQuoteBound = 'true';

      fallback.addEventListener('click', function () {
        var form = fallback.closest('.product-single__form');
        if (!form) return;

        var tries = 0;
        var activate = function () {
          var quoteButton = form.querySelector('.ify-quote-group .storeify-quote-btn-trigger-popup, .storeify-quote-btn-trigger-popup');
          if (quoteButton) {
            quoteButton.click();
            return true;
          }
          return false;
        };

        if (activate()) return;
        fallback.setAttribute('aria-busy', 'true');
        var timer = window.setInterval(function () {
          tries += 1;
          if (activate()) {
            window.clearInterval(timer);
            fallback.removeAttribute('aria-busy');
          } else if (tries >= 30) {
            window.clearInterval(timer);
            window.location.assign('/pages/contact-us-or-text-us?request=trade-quote');
          }
        }, 100);
      });
    });
  }

  function recommendationHasContent(discovery) {
    if (!discovery || !discovery.isConnected) return false;

    // The discovery app renders inside a shadow root. Do not use the host's
    // height as a readiness signal: our reserved loading height deliberately
    // makes an empty host tall enough to look "ready". Require actual product
    // content instead so an app failure always falls back to the native rail.
    var root = discovery.shadowRoot || discovery;
    var productLinks = root.querySelectorAll('a[href*="/products/"]').length;
    var productRecords = root.querySelectorAll('[data-product-id], [data-product-handle]').length;
    return productLinks > 0 || productRecords > 0;
  }

  function consolidateRecommendations() {
    var discovery = document.querySelector('ai-search-product-discovery[data-heading]');
    var nativeRail = document.querySelector('.fs-recommendation-rail');
    var nativeSection = nativeRail && nativeRail.closest('.shopify-section');
    if (!discovery || !nativeSection) return;

    if (discovery.dataset.fsRecommendationPrimary === 'true') {
      if (recommendationHasContent(discovery)) {
        discovery.classList.remove('fs-product-discovery--hydrating');
      }
      return;
    }

    // Put the app host in its final location before it hydrates so shoppers do
    // not see the native rail first and then watch the page swap underneath it.
    // The native rail stays in the DOM as a timed fail-open fallback.
    if (!nativeSection.parentNode) return;
    nativeSection.parentNode.insertBefore(discovery, nativeSection);
    discovery.dataset.fsRecommendationPrimary = 'true';
    discovery.classList.add('fs-product-discovery--primary', 'fs-product-discovery--hydrating');
    nativeSection.classList.remove('fs-recommendation-awaiting-app');
    nativeSection.removeAttribute('aria-busy');
    nativeSection.hidden = true;
    nativeSection.setAttribute('aria-hidden', 'true');
  }

  function primeRecommendations() {
    var nativeRail = document.querySelector('.fs-recommendation-rail');
    var nativeSection = nativeRail && nativeRail.closest('.shopify-section');
    if (!nativeSection || nativeSection.dataset.fsRecommendationPrimed === 'true') return;

    nativeSection.dataset.fsRecommendationPrimed = 'true';
    nativeSection.classList.add('fs-recommendation-awaiting-app');
    nativeSection.setAttribute('aria-busy', 'true');

    window.clearTimeout(recommendationFallbackTimer);
    recommendationFallbackTimer = window.setTimeout(function () {
      var discovery = document.querySelector('ai-search-product-discovery.fs-product-discovery--primary');
      if (recommendationHasContent(discovery)) {
        discovery.classList.remove('fs-product-discovery--hydrating');
        return;
      }

      if (discovery) {
        discovery.hidden = true;
        discovery.setAttribute('aria-hidden', 'true');
      }
      nativeSection.hidden = false;
      nativeSection.removeAttribute('aria-hidden');
      nativeSection.removeAttribute('aria-busy');
      nativeSection.classList.remove('fs-recommendation-awaiting-app');
    }, 10000);
  }

  function polish(scope) {
    applyCopy(scope);
    bindQuoteFallback(scope);
    consolidateRecommendations();
  }

  function queuePolish(scope) {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      polish(scope);
    });
  }

  function start() {
    var scope = document.querySelector('.template-product .product-single__meta') || document.querySelector('.product-single__meta');
    if (!scope) return;

    if (observer) observer.disconnect();
    primeRecommendations();
    polish(scope);
    window.setTimeout(function () { polish(scope); }, 500);
    window.setTimeout(function () { polish(scope); }, 1500);
    window.setTimeout(function () { polish(scope); }, 3000);
    window.setTimeout(function () { polish(scope); }, 6000);
    window.setTimeout(function () { polish(scope); }, 9000);
    var currentObserver = new MutationObserver(function () { queuePolish(scope); });
    observer = currentObserver;
    currentObserver.observe(scope, { childList: true, subtree: true, characterData: true });
    window.setTimeout(function () {
      currentObserver.disconnect();
      if (observer === currentObserver) observer = null;
    }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
}());

